const axiosInstance = require("axios");

const url = process.env.GATSBY_FLAGS_API;

module.exports = async function fetchFlags() {
  try {
    const secret =
      typeof window === "undefined" ? global.secret : window.idToken;
    const axios = axiosInstance.create({
      baseURL: url,
      headers: {
        "Content-Type": "application/json",
        authorization: `Bearer ${secret}`
      }
    });
    const { data } = await axios.post("/");
    return data;
  } catch (e) {
    throw e;
  }
};
